<template>

    <div class="page-container">

        <div class="main">

            <div class="top">
                <h3 class="intro-txt">{{$route.name}}</h3>
            </div>

            <page :url="url" :form="form">

                <template slot="tableSearch">

                    <el-form-item label="商户">
                        <el-select v-model="form.appId" filterable placeholder="--请选择--">
                            <el-option label="请选择" value=""></el-option>
                            <el-option v-for="merchant in merchantList" :label="merchant.merchantName" :key="merchant.appId"  :value="merchant.appId"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="提现日期">
                        <el-col :span="11">
                            <el-date-picker type="date" value-format="yyyyMMdd" placeholder="选择交易日期"
                                            v-model="form.startDate" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2" style="text-align: center;">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" value-format="yyyyMMdd" placeholder="选择交易日期"
                                            v-model="form.endDate" style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>

                </template>

                <template slot="buttonArea">
                    <el-button type="primary" @click="add" size="small" v-show="$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_NO_DEVICE || $store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_NO_DEVICE">分润提现</el-button>
                    <!--<el-button type="primary" @click="callMoney" size="small" v-show="$store.state.roleId === Constant.FIRST_AGENT_ROLE_WITH_DEVICE || $store.state.roleId === Constant.SECOND_AGENT_ROLE_WITH_DEVICE">进行打款</el-button>-->
                </template>

                <template slot="tableColumn">
                    <el-table-column
                            prop="orderId"
                            width="170px"
                            label="订单号">
                    </el-table-column>

                    <el-table-column
                            prop="amount"
                            :formatter="$formatter.Fen2Yuan"
                            width="100px"
                            label="提现金额">
                    </el-table-column>

                    <el-table-column
                            prop="fee"
                            :formatter="$formatter.Fen2Yuan"
                            width="100px"
                            label="手续费">
                    </el-table-column>

                    <el-table-column
                            prop="actualAmount"
                            :formatter="$formatter.Fen2Yuan"
                            width="120px"
                            label="实际到账金额">
                    </el-table-column>

                    <el-table-column
                            prop="withdrawType"
                            :formatter="$formatter.formatWithdrawType"
                            width="80px"
                            label="提现类型">
                    </el-table-column>

                    <el-table-column
                            prop="createDate"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="创建日期">
                    </el-table-column>

                    <el-table-column
                            prop="createTime"
                            width="150px"
                            :formatter="$formatter.formatDate"
                            label="创建时间">
                    </el-table-column>

                    <el-table-column
                            prop="status"
                            width="100px"
                            :formatter="$formatter.formatWithdrawStatus"
                            label="提现状态">
                    </el-table-column>

                    <el-table-column
                            prop="bankName"
                            width="100px"
                            label="银行名称">
                    </el-table-column>

                    <el-table-column
                            prop="branchName"
                            width="150px"
                            label="支行名称">
                    </el-table-column>

                    <el-table-column
                            prop="certName"
                            width="100px"
                            label="姓名">
                    </el-table-column>

                    <el-table-column
                            prop="bankCardNo"
                            width="200px"
                            label="银行卡号">
                    </el-table-column>

                    <el-table-column
                            prop="agentId"
                            width="150px"
                            label="代理商编号">
                    </el-table-column>

                    <el-table-column
                            prop="agentName"
                            width="150px"
                            label="代理商名称">
                    </el-table-column>

                    <el-table-column
                            prop="appId"
                            width="150px"
                            label="商户id">
                    </el-table-column>

                    <el-table-column
                            prop="merchantName"
                            width="150px"
                            label="商户名称">
                    </el-table-column>

                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="100">
                        <template slot-scope="scope">
                            <!--<el-button v-if="scope.row.withdrawType === '01' &&  scope.row.status === '00'" type="text" size="small" @click="setSuccess(scope.row)">设置为成功</el-button>-->
                            <!-- <el-button type="text" size="small" @click="deleteSystem(scope.row)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </template>
            </page>

            <AgentWithdrawInfoAdd :show.sync="showDialog" :formData="formData" :action="action"></AgentWithdrawInfoAdd>
            <AgentMakeMoneyAdd :show.sync="showCallMoneyDialog" :formData="formData" :action="action"></AgentMakeMoneyAdd>

        </div>
    </div>

</template>

<script>
    import Page from '@/components/Page.vue'
    import AgentWithdrawInfoAdd from './AgentWithdrawInfoAdd'
    import AgentMakeMoneyAdd from './AgentMakeMoneyAdd'
    import Constant from '../../utils/Constant'

    export default {
        name: "Systems",
        components: {
            'page': Page,
            AgentWithdrawInfoAdd: AgentWithdrawInfoAdd,
            AgentMakeMoneyAdd:AgentMakeMoneyAdd
        },

        data() {
            return {
                url: '/withdraw/selectListForAgent',
                action: '',
                form: {
                    startDate: "",
                    endDate: ""
                },
                showDialog: false,
                showCallMoneyDialog:false,
                formData: null,
                Constant:Constant,
                merchantList:[]
            }
        },
        methods: {
            add() {
                this.action = "addWithdraw";
                this.formData = null;
                this.showDialog = true;
            },
            callMoney(){
                this.action = "callMoney";
                this.formData = null;
                this.showCallMoneyDialog = true;
            }
        },
        created() {
            this.$axios.get("/merchant/selectListForAgent", {params: {}}).then(res => {
                this.merchantList = res.data.list;
            });
        }
    }
</script>

<style scoped>

</style>